export const RESERVATION_STATUS = {
  PENDING: 0,
  WAITING: 1,
  ACCEPTED: 2,
  CANCELLED: 3,
  REJECTED: 4,
  COMPLETED: 5,
  PAID: 6,
} as const;
export type ReservationStatus =
  (typeof RESERVATION_STATUS)[keyof typeof RESERVATION_STATUS];

export const RESERVATION_STATUS_LABEL: Record<ReservationStatus, string> = {
  [RESERVATION_STATUS.PENDING]: "pending",
  [RESERVATION_STATUS.WAITING]: "waiting",
  [RESERVATION_STATUS.ACCEPTED]: "accepted",
  [RESERVATION_STATUS.CANCELLED]: "cancelled",
  [RESERVATION_STATUS.REJECTED]: "rejected",
  [RESERVATION_STATUS.COMPLETED]: "completed",
  [RESERVATION_STATUS.PAID]: "paid",
};

export const CLIENT_STATUS = {
  PENDING: 0,
  ACTIVE: 1,
  BANNED: 2,
} as const;
export type ClientStatus = (typeof CLIENT_STATUS)[keyof typeof CLIENT_STATUS];

export const CLIENT_STATUS_LABEL: Record<ClientStatus, string> = {
  [CLIENT_STATUS.PENDING]: "pending",
  [CLIENT_STATUS.ACTIVE]: "active",
  [CLIENT_STATUS.BANNED]: "banned",
};

export const CATEGORY_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
} as const;
export type CategoryStatus =
  (typeof CATEGORY_STATUS)[keyof typeof CATEGORY_STATUS];

export const CATEGORY_STATUS_LABEL: Record<CategoryStatus, string> = {
  [CATEGORY_STATUS.ACTIVE]: "active",
  [CATEGORY_STATUS.INACTIVE]: "inactive",
};

export const ACTIVITY_STATUS = {
  ACTIVE: 1,
  PRIVATE: 2,
  DRAFT: 3,
} as const;
export type ActivityStatus =
  (typeof ACTIVITY_STATUS)[keyof typeof ACTIVITY_STATUS];

export const ACTIVITY_STATUS_LABEL: Record<ActivityStatus, string> = {
  [ACTIVITY_STATUS.ACTIVE]: "active",
  [ACTIVITY_STATUS.PRIVATE]: "private",
  [ACTIVITY_STATUS.DRAFT]: "draft",
};

export const COMBO_TYPE = {
  PERSON: 0,
  HOUR: 1,
  ROOM: 2,
  GROUP: 3,
} as const;
export type ComboType = (typeof COMBO_TYPE)[keyof typeof COMBO_TYPE];

export const COMBO_TYPE_LABEL: Record<ComboType, string> = {
  [COMBO_TYPE.PERSON]: "person",
  [COMBO_TYPE.HOUR]: "hour",
  [COMBO_TYPE.ROOM]: "room",
  [COMBO_TYPE.GROUP]: "group",
};

export const REVIEW_STATUS = ["pending", "approved", "rejected"] as const;
export type ReviewStatus = (typeof REVIEW_STATUS)[number];

export const USER_ROLES = ["admin", "staff", "customer"] as const;
export type UserRole = (typeof USER_ROLES)[number];
